import { render, staticRenderFns } from "./LKRoadmapsFeedLabelStatus.vue?vue&type=template&id=4dab882e&"
import script from "./LKRoadmapsFeedLabelStatus.vue?vue&type=script&lang=js&"
export * from "./LKRoadmapsFeedLabelStatus.vue?vue&type=script&lang=js&"
import style0 from "./LKRoadmapsFeedLabelStatus.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports